import { getStoredItem, setStoredItem } from '../stored-item'

const includeJsFile = ({ link, async, onload = () => {}, parameter, idLoadOnce, idLoadOnceAtSession }) => {
  const script = document.createElement('script')

  script.src = link
  script.type = 'text/javascript'
  script.defer = true
  script.async = async

  if (onload !== undefined) {
    script.addEventListener('load', function (event) {
      onload(parameter)
    })
  }

  if (idLoadOnce) {
    script.id = idLoadOnce
    if (document.getElementById(idLoadOnce)) {
      return false
    }
  }

  if (idLoadOnceAtSession) {
    script.id = idLoadOnceAtSession
    const isLoaded = getStoredItem(idLoadOnceAtSession)
    console.log(isLoaded)
    if (isLoaded) {
      return false
    }
    setStoredItem(idLoadOnceAtSession, true)
    console.log('setStoredItem', getStoredItem(idLoadOnceAtSession))
  }

  document.getElementsByTagName('head').item(0).appendChild(script)
}

export default includeJsFile
